import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'aktiveFilter',
    standalone: false
})
export class AktiveFilterPipe implements PipeTransform {

  transform(value: string | number): string | number {
    if (value === 'aktiv') {
      return 'Aktiv gemanagt';
    }
    if (value === 'passiv') {
      return 'Passiv gemanagt';
    }
    if (value === 6) {
      return 'Standard (Artikel 6)';
    }
    if (value === 8) {
      return 'ESG-Produkt (Artikel 8)';
    }
    if (value === 9) {
      return 'Impact Produkt (Artikel 9)';
    }
    if (value === 'greenhouseEmissions') {
      return 'Treibhausgas-Emission';
    }
    if (value === 'water') {
      return 'Wasser';
    }
    if (value === 'waste') {
      return 'Abfälle';
    }
    if (value === 'biodiversity') {
      return 'Biologische Diversität';
    }
    if (value === 'socialMatters') {
      return 'Soziale - und Arbeitnehmerbelange';
    }


    return value;
  }

}
